import React, { Component } from 'react';
import Table from 'rc-table';
import Checkbox from 'rc-checkbox';
import VinculacionDropdown from './VinculacionDropdown';
import { Icon } from 'react-fa';
import { GenericAlert } from 'com-gyf-webcore-userinterfacecomponents';

function esTitular(row) {
    return row.vinculo.toLowerCase() === "titular";
}

let _seleccionoTodo = false;

const ParentCheckBox = ({ clickFn, cuentasVinculadas, cuentas }) => {
    return (
        <div>
            <Checkbox
                checked={_seleccionoTodo}
                className="ParentCheck"
                onClick={() => clickFn()}
            />
        </div>
    );
}

const CheckedRowField = ({ checked, row, clickFn }) => {

    if (esTitular(row))
        return <Checkbox className="ParentCheck" disabled={true} />;

    return <Checkbox checked={checked} className="ParentCheck" onClick={() => clickFn(row)} />;
}

const Alerta = (props) => {
    if (props.mostrarError == 1) {
        return <GenericAlert message="Por favor, seleccione alguna cuenta para continuar." type="warning" />;
    } else if (props.mostrarError == 2) {
        return <GenericAlert message="Por favor, seleccione alguna cuenta como principal." type="warning" />;
    } else {
        return null;
    }
}

class VinculacionCuentas extends Component {

    constructor(props) {
        super(props);

        this.state = {
            seleccionoTodo: false
        }

        this.columnsPendientes = [
            {
                dataIndex: 'checked',
                key: 'checked',
                render: (checked, row) => row.estado !== 'T' && row.estado !== 't' ? <span><Icon name="trash" className="hand-pointer" size="lg" onClick={() => props.borrarVinculo(row.cuenta)} /> </span> : null
            },
            {
                title: 'TIPO',
                dataIndex: 'tipo',
                key: 'tipo',
            },
            {
                title: '',
                dataIndex: 'numeroConFormato',
                key: 'numeroConFormato',
            },
            {
                title: 'VINCULO',
                dataIndex: 'vinculo',
                key: 'vinculo'
            },
            {
                title: 'SUCURSAL',
                dataIndex: 'sucursal',
                key: 'sucursal'
            },
            {
                title: 'ACCION',
                dataIndex: 'accion',
                key: 'accion'
            },
            {
                title: 'TARJETAS',
                dataIndex: 'tarjetas',
                key: 'tarjetas',
                render: (cant) => <p>{cant} tarjetas asociadas</p>
            }
        ];

        this.columns = [
            {
                title: <ParentCheckBox clickFn={() => this.toggleCheckAll()} />,
                dataIndex: 'checked',
                key: 'checked',
                render: (checked, row) => <CheckedRowField row={row} checked={checked} clickFn={(row) => this.toggleChecked(row)} />
            },
            {
                title: 'TIPO',
                dataIndex: 'tipo',
                key: 'tipo',
            },
            {
                title: '',
                dataIndex: 'numeroConFormato',
                key: 'numeroConFormato',
            },
            {
                title: 'VINCULO',
                dataIndex: 'vinculo',
                key: 'vinculo'
            },
            {
                title: 'SUCURSAL',
                dataIndex: 'sucursal',
                key: 'sucursal'
            },
            {
                title: 'TARJETAS',
                dataIndex: 'tarjetas',
                key: 'tarjetas',
                render: (cant) => <p>{cant} tarjetas asociadas</p>
            }
        ];
    }

    componentDidMount() {
        this.props.getVinculaciones(this.props.tarjetaActual, this.props.plasticos.cuentasDelivery, this.props.plasticos.tarjetas);
    }

    toggleCheckAll() {
        this.setState({ seleccionoTodo: !this.state.seleccionoTodo });
        this.props.agregarQuitarCuentaVinculo(-1, this.state.seleccionoTodo, this.props.plasticos.cuentasDelivery);
        _seleccionoTodo = this.state.seleccionoTodo;
    }

    toggleChecked(row) {
        this.props.agregarQuitarCuentaVinculo(row.numero, undefined, this.props.plasticos.cuentasDelivery);
    }

    mostrarVinculos() {
        this.props.mostrarVinculos();
    }

    render() {

        let noMuestraSeleccionVinculos = true
        let tarjetas = this.props.plasticos.tarjetas;
        let cuentas = this.props.plasticos.cuentasDelivery;
        let vinculos = this.props.data.vinculosNroTarjeta;
        let tarjetaActual = this.props.tarjetaActual;
        let vinculacionesPendientes = [];
        let vinculaciones = [];
        let cantidadTarjetas = 0;
        let iKey = 0;

        if (vinculos !== undefined) {
            for (var i = 0; i < vinculos.length; i++) {
                let cuenta = cuentas.find(x => x.CodigoCuenta == vinculos[i].NumeroCuenta);

                if (cuenta !== undefined) {

                    for (var j = 0; j < tarjetas.length; j++) {
                        if (tarjetas[j].NumeroCuenta == cuenta.CodigoCuenta)
                            cantidadTarjetas += 1;
                    }

                    let solicitud = this.props.plasticos.solicitudes.find(x => x.Id == vinculos[0].TdSolicitudId);

                    if (vinculos[i].borrado === false || vinculos[i].borrado === undefined) {
                        let sucursal = this.props.plasticos.sucursalesDelivery.find(x => x.Codigo == cuenta.Sucursal);
                        let sucursalDesc = sucursal !== undefined ? sucursal.Descripcion : '';

                        let tipoCuenta = '';
                        switch (cuenta.Vinculo.toString()) {
                            case "1":
                                tipoCuenta = 'Titular Princip';
                                break
                            case "2":
                                tipoCuenta = 'Titular no Firm';
                                break;
                            case "3":
                                tipoCuenta = 'Otro titular';
                                break;
                            case "4":
                                tipoCuenta = 'Apoderado';
                                break;
                            case "5":
                                tipoCuenta = 'Firmante';
                                break;
                            case "6":
                                tipoCuenta = 'Rep. legal';
                                break;
                            default:
                                tipoCuenta = '';
                                break;
                        }

                        vinculacionesPendientes.push({
                            key: iKey,
                            tipo: cuenta.NombreProducto,
                            numero: cuenta.CodigoCuenta,
                            vinculo: tipoCuenta,
                            sucursal: cuenta.Sucursal + " - " + sucursalDesc,
                            tarjetas: cantidadTarjetas,
                            checked: vinculos[i].Accion == 'N' ? true : false,
                            cuenta: cuenta,
                            numeroConFormato: 'N' + String.fromCharCode(186) + cuenta.CodigoCuenta,
                            accion: vinculos[i].Accion == 'D' ? 'Desvinculación' : 'Vinculación ',
                            estado: solicitud !== undefined ? solicitud.Estado : null
                        })

                        iKey++;
                    }
                }
            }
        }

        noMuestraSeleccionVinculos = false;
        iKey = 0;

        if (cuentas !== undefined) {
            for (var i = 0; i < cuentas.length; i++) {

                let checked = false;

                let seleccionado = this.props.data.cuentasVinculadas.find(x => x.numero == cuentas[i].CodigoCuenta);

                if (seleccionado !== undefined)
                    checked = seleccionado.checked;

                cantidadTarjetas = 0;
                for (var j = 0; j < tarjetas.length; j++) {
                    if (tarjetas[j].NumeroCuenta == cuentas[i].CodigoCuenta)
                        cantidadTarjetas += 1;
                }

                let v = undefined;
                if (vinculos !== undefined) {
                    v = vinculos.find(x => x.NumeroCuenta == cuentas[i].CodigoCuenta);
                }

                if (v === undefined || v.borrado) {

                    let sucursal2 = this.props.plasticos.sucursalesDelivery.find(x => x.Codigo == cuentas[i].Sucursal);
                    let sucursalDesc2 = sucursal2 !== undefined ? sucursal2.Descripcion : '';

                    vinculaciones.push({
                        key: iKey,
                        tipo: cuentas[i].NombreProducto,
                        numero: cuentas[i].CodigoCuenta,
                        vinculo: cuentas[i].NombreVinculo,
                        sucursal: cuentas[i].Sucursal + " - " + sucursalDesc2,
                        tarjetas: cantidadTarjetas,
                        checked: checked,
                        cuenta: cuentas[i],
                        numeroConFormato: 'N' + String.fromCharCode(186) + cuentas[i].CodigoCuenta,
                    })

                    iKey++;
                }
            }
        }

        return (
            <div>
                <h2>VINCULACIONES EN CURSO</h2>
                <Alerta mostrarError={this.props.data.vinculacionError} />
                <Table
                    columns={this.columnsPendientes}
                    data={vinculacionesPendientes}
                    emptyText="No existen tarjetas vinculadas."
                    className="table-vinculacion-cuenta"
                />

                <h2>VINCULACIONES</h2>
                <Table
                    columns={this.columns}
                    data={vinculaciones}
                    emptyText="No existen tarjetas vinculadas."
                    className="table-vinculacion-cuenta"
                />
                <VinculacionDropdown cuentas={vinculaciones} cambiarCuentaPrincipal={this.props.cambiarCuentaPrincipal} data={this.props.data} cuentasSeleccionadas={this.props.data.cuentasVinculadas} noMuestraSeleccionVinculos={noMuestraSeleccionVinculos} />
            </div>
        );
    }

}

export default VinculacionCuentas;
